<template>
  <span
    :class="[bemBlock, 'price']"
    itemprop="offers"
    itemscope
    itemtype="http://schema.org/Offer"
  >
    <meta itemprop="priceCurrency" :content="price.currency" />
    <span v-if="title" :class="bemElement('title')">
      {{ title }}
    </span>
    <p
      v-if="originalPrice && originalPrice.text !== null && isTotalPrice"
      :class="bemElement('promo-text')"
    >
      {{ $msg('line-item-total-price.promo-text', 'cart') }}
    </p>
    <span
      v-if="!hideDiscount && originalPrice && originalPrice.text !== null"
      :class="bemElement('original-price')"
    >
      {{ originalPrice.text }}
    </span>
    <span :class="bemElement('price')" :content="price.value" itemprop="price">
      {{ price.text }}
    </span>
    <span v-if="!hideDiscount && hasDiscount()" :class="bemElement('discount')">
      {{ formattedDiscountPercent }}
    </span>
    <BaseInfoMsg
      v-if="showPreviousPriceMsg && additionalInfoPrice.text"
      :class="bemElement('msg')"
      :text="additionalInfoPrice.text"
      :text-tooltip="
        showPreviousPriceMsgTooltip ? additionalInfoPrice.tooltip : null
      "
    />
  </span>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import productPropPriceMixin from '../mixins/productPropPriceMixin';
import BaseInfoMsg from './BaseInfoMsg.vue';
import getFrontConfig from '../../common/getFrontConfig';

const {
  vue: {
    BasePrice: {
      context: { totalPrice, unitPrice },
    },
  },
} = getFrontConfig();

export default {
  name: 'BasePrice',

  components: {
    BaseInfoMsg,
  },

  mixins: [bemClassesMixin, productPropPriceMixin],

  props: {
    context: {
      type: String,
      validator: (prop) => [unitPrice, totalPrice].includes(prop),
      default: unitPrice,
    },
    showPreviousPriceMsg: {
      type: Boolean,
      default: false,
    },
    showPreviousPriceMsgTooltip: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    /**
     * Show only what the customer pays: no struck-through price and no
     * discount percentage. Hiding the price altogether is the caller's
     * decision, not this one.
     */
    hideDiscount: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isTotalPrice: this.context === totalPrice,
    };
  },

  computed: {
    formattedDiscountPercent() {
      return `${this.discountPercent}%`;
    },
  },
};
</script>
